import { action, thunk, persist } from 'easy-peasy';
import { httpGetBasicData } from "services/stocks";

const model = {
  loading: false,
  setLoading: action((state, payload) => {
    state.loading = payload
  }),
  objects: [
    /*
    {id: 1, name: "Osake A"},
    {id: 2, name: "Osake B"},
    {id: 3, name: "Osake C"},
    */
  ],
  setObjects: action((state, payload) => {
    if (payload) {
      state.objects = [
        ...payload,
      ]
    }
  }),
  addObject: action((state, payload) => {
    state.objects = [
      ...state.objects,
      payload,
      // loggedIn: true,
    ]
  }),
  getObjects: thunk(async (actions, payload) => {
    actions.setLoading(true)
    const params = {
      stock_market: 'XHEL',
      ordering: 'name',
      ...payload,
    }
    httpGetBasicData(params).then(response => {
      actions.setObjects(response?.data)
    }, error => {
      
    }).finally(() => {
      actions.setLoading(false)
    })
    
  }),

  count: 0,
  setCount: action((state, payload) => {
    state.count = payload
  }),
  
};

export default model;